import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { ScheduledRideCalendarRecordsQueryVariables } from '@/gql/graphql';

export const fetchScheduledRideCalendarRecords = async ({
  phoneNumber,
  startDate,
  endDate,
  isAllSpecialRequestAndPharmacy,
}: ScheduledRideCalendarRecordsQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      phoneNumber,
      startDate,
      endDate,
      isAllSpecialRequestAndPharmacy,
      pagination: {
        offset: 0,
        limit: 0, // return all records from startDate to endDate
      },
    },
    query: graphql(`
      query ScheduledRideCalendarRecords(
        $pagination: PaginationInputType
        $phoneNumber: String
        $startDate: String
        $endDate: String
        $isAllSpecialRequestAndPharmacy: Boolean
      ) {
        scheduledRides(
          pagination: $pagination
          phoneNumber: $phoneNumber
          startDate: $startDate
          endDate: $endDate
          isAllSpecialRequestAndPharmacy: $isAllSpecialRequestAndPharmacy
        ) {
          count
          rows {
            id
            rideName
            canceledAt
            completedAt
            dateTimes
            timeZone
            serviceType
            confirmedAt
            returnTime
          }
        }
      }
    `),
  });

  return response.data.scheduledRides;
};
